import styled from 'styled-components'
import AppButton from 'Components/AppButton'

export const _VerifyEmailCard = styled.div`
  width: 400px;
  padding: 32px;
  background-color: white;

  @media screen and (max-width: 414px) {
    width: 280px;
    padding: 16px;
  }
`

export const _CardTitle = styled.div`
  width: 100%;
  font-weight: 500;
  font-size: 22px;
  line-height: 30px;
  margin-bottom: 16px;
`

export const _AppButtonCta = styled(AppButton)`
  width: 100%;
`
